/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author HyeongJin O
 * @contact hjoh@detech.co.kr
 * @date 2022-09-28
 * @brief EHP 사용자 메일 인증 성공 개발
 *
 ********************************************************************/
import React from "react";
import { useNavigate } from "react-router-dom";
/**
 * @brief EHP 이메일 인증 성공 컴포넌트
 * @param -
 * @returns react components
 */
function OkEhpCertification() {
    const navigate = useNavigate();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "login__right webmailok" },
            React.createElement("h2", null,
                React.createElement("p", { className: "tit" }, "\uC778\uC99D \uC644\uB8CC")),
            React.createElement("div", { className: "login__form" },
                React.createElement("form", { action: "#", method: "", name: "loginform" },
                    React.createElement("fieldset", null,
                        React.createElement("p", { className: "login__info" }, "\uBA54\uC77C \uC778\uC99D\uC774 \uC815\uC0C1\uC801\uC73C\uB85C \uC644\uB8CC \uB418\uC5C8\uC2B5\uB2C8\uB2E4."),
                        React.createElement("button", { type: "button", className: "btn-login", onClick: (e) => navigate("/") },
                            React.createElement("span", null, "\uB85C\uADF8\uC778\uD558\uAE30"))))))));
}
export default OkEhpCertification;
